import forgotPasswordConstants from '../constants/forgot-password-constants';
import constants from '../../../../common/constants';

export const validate = values => {
  const errors = {};

  if (!values[forgotPasswordConstants.fields.email]) {
    errors[forgotPasswordConstants.fields.email] = 'REGISTER.EMAIL_REQUIRED';
  }

  if (values[forgotPasswordConstants.fields.email] && !constants.email_regex.test(values[forgotPasswordConstants.fields.email])) {
    errors[forgotPasswordConstants.fields.email] = 'COMMON.EMAIL_VALID';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/main/forgot-password/validators/forgot-password-validators.js